import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { useId } from 'react-id-generator';
import { mergeProps } from '../../utils/react.js';
import { noop } from '../../utils/util.js';
import { useButtonMenuContext, FOCUS_ELEMENTS } from '../ButtonMenuContainer/ButtonMenuContainer.js';
import { MenuItem } from '../MenuItem/MenuItem.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["as", "itemIndex", "onActivate"];
var defaultElement = "li";
var ButtonMenuItem = /*#__PURE__*/React.forwardRef(function ButtonMenuItem2(props, ref) {
  var context = useButtonMenuContext();
  var _props$as = props.as,
    as = _props$as === void 0 ? defaultElement : _props$as,
    itemIndex = props.itemIndex,
    _props$onActivate = props.onActivate,
    onActivate = _props$onActivate === void 0 ? noop : _props$onActivate,
    rest = _objectWithoutProperties(props, _excluded);
  var id = useId(1, "_mntl-button-menu-item-")[0];
  var handleActivate = function handleActivate(e) {
    var target = e.currentTarget;
    if (target.getAttribute("aria-haspopup") === "dialog") {
      context.setCloseOnOutsideClick(false);
    } else {
      context.setFocusItem(FOCUS_ELEMENTS.BUTTON);
      context.setShowingState(false);
    }
    onActivate(e);
  };
  var handleFocus = function handleFocus() {
    context.setCloseOnOutsideClick(true);
  };
  return /*#__PURE__*/jsx(MenuItem, _objectSpread({
    as: as
  }, mergeProps(_objectSpread(_objectSpread({}, rest), {}, {
    ref: ref
  }), {
    onActivate: handleActivate,
    onFocus: handleFocus,
    id: id,
    itemIndex: itemIndex
  })));
});
ButtonMenuItem.displayName = "ButtonMenuItem";

export { ButtonMenuItem, defaultElement };
